define('Components/AboutCornerWidget/js/views/AboutCornerWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/AboutCornerWidget/templates/header',
    'InternalLinkView',
    'router'
],
function($, WidgetInstanceView, app, headerTemplate, InternalLinkView, router){
    var templates = {
        header: headerTemplate,
    }
    return WidgetInstanceView.extend({
        name: 'AboutCornerWidgetInstanceView',
        events: {
            'click .about-corner-button': 'scrollToForm'
        },

        afterRender:function(){
            var view = this;
        },

        getTemplate: function () {
            return templates[this.model.getTemplate()] || null;
        },

        scrollToForm: function(e) {
            e.preventDefault()
            app.scrollTop($('.job-widget').offset().top, 400)
        }
    })
});
